import React, { useState } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PersonalInfoForm } from "@/components/Calculator/PersonalInfoForm";
import { useCalculatorState } from "@/components/Calculator/hooks/useCalculatorState";

interface HeroProps {
  scrollToCalculator: () => void;
}

const Hero: React.FC<HeroProps> = ({ scrollToCalculator }) => {
  const [showForm, setShowForm] = useState(false);
  const {
    formData,
    isSubmitting,
    actions
  } = useCalculatorState();
  return (
    <section className="relative w-full px-4 md:px-6 pt-4 md:pt-16 pb-12 md:pb-24 overflow-hidden bg-gradient-to-b from-accent to-background overflow-x-hidden">
      <div className="absolute inset-0 opacity-40 bg-hero-pattern" aria-hidden="true"></div>
      <div className="container relative max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6 md:gap-10 items-center">
          <div className="order-2 md:order-1 flex flex-col max-w-2xl mx-auto text-center md:text-left space-y-4">
            <div className="animate-fade-in">
              <p className="text-xs md:text-sm tracking-widest font-semibold uppercase text-primary mb-2">
                Equiparação Hospitalar · Lucro Presumido
              </p>
              <h1 className="text-[clamp(1.5rem,6vw,3rem)] md:text-3xl lg:text-5xl font-bold tracking-tight text-foreground leading-tight text-balance">
                Equiparação Hospitalar para Médicos: Economize até <span className="text-primary">70% de Impostos</span>
              </h1>
            </div>
            <div className="mt-3 md:mt-4 animate-fade-up space-y-4">
              <p className="text-base md:text-lg font-semibold text-foreground">
                Para médicos, clínicas, laboratórios e hospitais no Lucro Presumido.
              </p>
              <p className="hidden md:block text-sm md:text-base text-muted-foreground leading-relaxed">
                Reduza IRPJ e CSLL de 32% para 8% e restitua até 60 meses de impostos pagos a mais. 100% administrativo, sem ação judicial.
              </p>

              {/* Prova social */}
              <ul className="flex flex-wrap justify-center md:justify-start gap-x-4 gap-y-2 text-xs md:text-sm font-medium text-foreground">
                <li className="flex items-center gap-1.5"><span className="text-primary">✓</span> +500 clínicas atendidas</li>
                <li className="flex items-center gap-1.5"><span className="text-primary">✓</span> 100% remoto</li>
                <li className="flex items-center gap-1.5"><span className="text-primary">✓</span> Sem ação judicial</li>
              </ul>
            </div>
          </div>

          <div className="hidden md:block order-1 md:order-2 w-full">
            <Card className="shadow-lg overflow-hidden">
              <CardContent className="pt-6 p-4 md:p-6">
                {!showForm ? (
                  <>
                    <div className="bg-gradient-to-r from-[hsl(142,72%,45%)] to-[hsl(142,72%,55%)] text-white rounded-t-lg mx-0 md:-mx-6 -mt-6 px-4 md:px-6 py-3 md:py-4 mb-4">
                      <h2 className="text-sm md:text-lg font-semibold break-words">Verifique sua elegibilidade agora no WhatsApp!</h2>
                    </div>
                    <div className="flex flex-col items-center gap-4 py-6">
                      <p className="text-center text-muted-foreground">
                        Descubra como economizar nos impostos da sua clínica ou consultório.
                      </p>
                      <Button
                        onClick={() => setShowForm(true)}
                        className="w-full min-h-[56px] bg-[hsl(142,72%,45%)] hover:bg-[hsl(142,72%,38%)] text-white font-semibold text-sm md:text-lg whitespace-normal"
                      >
                        <MessageCircle className="w-6 h-6 mr-2" />
                        Fale com nosso time agora no WhatsApp!
                      </Button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="bg-gradient-to-r from-[hsl(142,72%,45%)] to-[hsl(142,72%,55%)] text-white rounded-t-lg mx-0 md:-mx-6 -mt-6 px-4 md:px-6 py-3 md:py-4 mb-4">
                      <h2 className="text-sm md:text-lg font-semibold break-words">Preencha para falar no WhatsApp</h2>
                    </div>
                    <PersonalInfoForm
                      formData={formData}
                      onChange={actions.handleChange}
                      onSubmit={actions.handleSubmit}
                      isSubmitting={isSubmitting}
                    />
                  </>
                )}
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
